import React from "react";
import { Route, Routes } from "react-router-dom";

import NotFound from "~/components/NotFound/NotFound";

import MarketingAnalytics from "./MarketingAnalytics";

const MarketingAnalyticsRouter = (): React.ReactElement => {
  return (
    <Routes>
      <Route index element={<MarketingAnalytics />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default MarketingAnalyticsRouter;
